import { Link, useLocation } from "react-router-dom";
import "./HeaderTabs.Component.scss";

interface Props {
    items: { to: string; label: string }[];
}

export function HeaderTabsComponent(props:Props) {
    return (
        <div className="HeaderTabsComponent">
            {props.items.map((item, index) => (
                <HeaderTabsComponentItem key={index} to={item.to}>
                    {item.label}
                </HeaderTabsComponentItem>
            ))}
            
        </div>
    );
}

interface HeaderTabsComponentItemProps {
    children: React.ReactNode;
    to: string;
    useATag?: boolean;
    supressMatch?: boolean;
    excludeMatch?: string;
    selected?: boolean;

  }
  
 function HeaderTabsComponentItem(props: HeaderTabsComponentItemProps) {
    const Tag: any = props.useATag ? 'a' : Link;
    let selected = props.selected;
  
    if (!props.supressMatch) {
      let location = useLocation();
  
      if (location.pathname.indexOf(props.to) >= 0) {
        if (
          props.excludeMatch &&
          location.pathname.indexOf(props.excludeMatch) > -1
        ) {
          selected = false;
        } else {
          selected = true;
        }
      }
    }
  
    return (
      <Tag
        {...(props.useATag ? { href: props.to } : { to: props.to })}
        className={`HeaderTabsComponentItem ${selected ? 'selected' : ''}`}
      >
        {props.children}
      </Tag>
    );
  }
  